import { ITranslations } from 'types/common';
import { PointRequestFormTransFields } from './types';
import en from 'translations/en/pointRequestForm.json';
import pl from 'translations/pl/pointRequestForm.json';
import sl from 'translations/sl/pointRequestForm.json';

export const pointRequestFormTranslations: ITranslations<PointRequestFormTransFields> = {
  name: 'pointRequestForm',
  en,
  pl,
  sl,
};
